/** Local clock on an operation site in Córdoba, Argentina (ART UTC-03:00). */
const LOCAL = /^\d{4}-\d\d-\d\dT\d\d:\d\d$/;
export interface QuoteInput {
  customer_id: string;
  location: string;
  asset_type: string;
  starts_at: string;
  ends_at: string;
  price_ars: number;
}
export function createQuoteInput(fields: Record<string, string>): QuoteInput {
  const {customer_id,location,asset_type,starts_at,ends_at,price_ars}=fields;
  if(!customer_id || !location?.trim() || !asset_type?.trim()) throw Error("Completá el cliente, la obra y el tipo de contenedor.");
  if(!LOCAL.test(starts_at ?? "") || !LOCAL.test(ends_at ?? "")) throw Error("Ingresá fechas y horarios válidos.");
  const begin=Date.parse(starts_at+"-03:00"),end=Date.parse(ends_at+"-03:00");
  if(!Number.isFinite(begin)||!Number.isFinite(end)||new Date(begin-3*3600000).toISOString().slice(0,16)!==starts_at||new Date(end-3*3600000).toISOString().slice(0,16)!==ends_at||end<=begin||end-begin>45*86400000) throw Error("El alquiler debe durar entre 1 minuto y 45 días.");
  if(!/^\d{1,10}$/.test(price_ars ?? ""))throw Error("Ingresá un importe entero en pesos argentinos.");
  const price=Number(price_ars);
  if(!Number.isSafeInteger(price)||price<=0)throw Error("El importe debe ser mayor a cero.");
  return {customer_id,location:location.trim(),asset_type:asset_type.trim(),starts_at:new Date(begin).toISOString(),ends_at:new Date(end).toISOString(),price_ars:price};
}
export function orderIdempotencyKey(randomUUID:()=>string=()=>crypto.randomUUID()):string {
  const value=randomUUID();
  if(!/^[A-Za-z0-9_-]{8,100}$/.test(value))throw Error("No fue posible generar una clave de pedido segura.");
  return value;
}
